const DURATION_LABELS = {
  days: {
    singular: 'CLUB_SKYWORK_AFFILIATION_PAYMENT_PER_DAY',
    plural: 'CLUB_SKYWORK_AFFILIATION_DURATION_DAYS'
  },
  months: {
    singular: 'CLUB_SKYWORK_AFFILIATION_PAYMENT_PER_MONTH',
    plural: 'CLUB_SKYWORK_AFFILIATION_DURATION_MONTHS'
  },
  years: {
    singular: 'CLUB_SKYWORK_AFFILIATION_PAYMENT_PER_YEAR',
    plural: 'CLUB_SKYWORK_AFFILIATION_DURATION_YEARS'
  }
};

const positiveNumber = value => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

export const createAffiliationRequestState = affiliation => {
  const status = affiliation.renewalPending
    ? affiliation.status === 'expired'
      ? 'expired_renewal_pending'
      : 'renewal_pending'
    : affiliation.status;

  if (affiliation.renewalAllowed) {
    return {action: 'renew', disabled: false, status};
  }
  if (status === 'available') {
    return {action: 'request', disabled: false, status};
  }
  return {action: null, disabled: true, status};
};

export const createAffiliationCommercialDetails = ({affiliation, formatPrice, translate}) => {
  const benefits = [];
  const discount = positiveNumber(affiliation.discount);
  const visibilityCalendarDays = positiveNumber(affiliation.visibilityCalendarDays);
  const duration = positiveNumber(affiliation.duration);
  const durationLabels = DURATION_LABELS[affiliation.durationType];
  const hasPaymentPrice = Boolean(affiliation.onlinePayment)
    && affiliation.priceEur !== undefined
    && affiliation.priceEur !== null;
  let paymentLabel = null;

  if (hasPaymentPrice) {
    const price = formatPrice(affiliation.priceEur);

    if (affiliation.renewalType !== 'life_time' && durationLabels && duration === 1) {
      paymentLabel = translate(durationLabels.singular, {price});
    } else if (affiliation.renewalType !== 'life_time' && durationLabels && duration > 1) {
      paymentLabel = translate('CLUB_SKYWORK_AFFILIATION_PAYMENT_EVERY', {
        duration,
        price,
        unit: translate(durationLabels.plural)
      });
    } else {
      paymentLabel = translate('CLUB_SKYWORK_AFFILIATION_PAYMENT_ONE_TIME', {price});
    }
  }

  if (discount !== null) {
    benefits.push({
      id: 'discount',
      label: translate('CLUB_SKYWORK_AFFILIATION_DISCOUNT', {discount})
    });
  }

  if (visibilityCalendarDays !== null) {
    benefits.push({
      id: 'calendar',
      label: translate('CLUB_SKYWORK_AFFILIATION_CALENDAR_VISIBILITY', {
        days: visibilityCalendarDays
      })
    });
  }

  return {benefits, paymentLabel};
};
